/* eslint-disable @angular-eslint/directive-selector */
import { Directive } from '@angular/core';

@Directive({
  selector: 'zef-form-label'
})
export class ZefFormLabelDirective { }
